import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/icons/delete.png';
const _hoisted_1 = ["disabled"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        text: {
            type: String
        },
        type: {
            type: String
        },
        isDisable: {
            type: Boolean,
            default: false
        },
        class: {
            type: String
        }
    },
    emits: ["handleClick"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const handleClick = () => {
            emit('handleClick', props.text);
        };
        return (_ctx, _cache) => {
            return (props.type == 'remove')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: handleClick,
                    class: "px-3 py-12px border-size-button border-remove-color font-remove-color button-style bg-remove"
                }, [
                    _createTextVNode(_toDisplayString(props.text) + " ", 1),
                    _cache[0] || (_cache[0] = _createElementVNode("span", null, [
                        _createElementVNode("img", {
                            class: "ml-2 d-inline-block",
                            src: _imports_0
                        })
                    ], -1))
                ]))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: _normalizeClass(["px-4 py-12px border-size-button button-style", [
                            props.type === 'regular' ? (props.isDisable ?
                                'border-disabled-color font-disabled-color' :
                                'border-regular-color font-regular-color') : (props.isDisable ?
                                'border-disabled-color font-disabled-color' :
                                'border-primary-color font-primary-color'),
                            props.class
                        ]
                    ]),
                    disabled: props.isDisable,
                    onClick: handleClick
                }, _toDisplayString(props.text), 11, _hoisted_1));
        };
    }
});
